module.exports = __webpack_public_path__ + "a55d5572efc77f01f487b1dfa1fdfaf5.svg";